// src/components/store/sections/faqs/FaqV42CyberterminalCoralFlame.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV42CyberterminalCoralFlame(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={42}
      archKey="cyber_terminal"
      archLabel="Cyber Terminal Help"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
